module.exports = __webpack_public_path__ + "img/25.6c2dd67.jpg";